export class CvFilterModel {
  field?: string;
  operator?: QueryOperator; // equal or includes
  values?: string[];
  logicalOperator?: LogicalOperator; // AND, OR
  filterType?: ValuesType; // TEXT or DROPDOWN

  constructor(field?: string,
              operator?: QueryOperator,
              values?: string[],
              logicalOperator?: LogicalOperator,
              filterType?: ValuesType
  ) {
    this.field = field;
    this.operator = operator;
    this.values = values;
    this.logicalOperator = logicalOperator;
    this.filterType = filterType;
  }
}

export enum LogicalOperator {
  AND = 'AND',
  OR = 'OR'
}

export enum QueryOperator {
  LIKE = 'includes',
  EQUALS = 'equals'
}

export enum ValuesType {
  TEXT = 'TEXT',
  DROPDOWN = 'DROPDOWN'
}
